import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M18.5 8H7.167M18.5 2.429H7.167M18.5 13.57H7.167M3.389 8a.937.937 0 0 1-.945.929A.937.937 0 0 1 1.5 8c0-.513.423-.929.944-.929.522 0 .945.416.945.929m0-5.571a.937.937 0 0 1-.945.928.937.937 0 0 1-.944-.928c0-.513.423-.929.944-.929.522 0 .945.416.945.929m0 11.142a.937.937 0 0 1-.945.929.937.937 0 0 1-.944-.929c0-.512.423-.928.944-.928.522 0 .945.416.945.928"
    }, null, -1)
  ]))]))
}
export default { render: render }